import ToggleWithIcon from "@/app/components/ui/Toggles/ToggleWithIcon";

const AnalyticsSwicthComponent = ({ isChecked, setIsChecked }) => {
  return (
    <div
      data-tooltip-id="show_analytics"
      data-tooltip-content="Show Analytics"
      className=" top-2 right-2 flex justify-start items-center gap-x-2"
    >
      <p>Show Analytics</p>
      <ToggleWithIcon
        toggleState={isChecked}
        onToggleChange={(status) => {
          setIsChecked(status);
        }}
      />
    </div>
  );
};

export default AnalyticsSwicthComponent;
